<script setup lang="ts">
import { inject, Ref } from 'vue';
import SelectTourProcess from './SelectTourProcess.vue';

const dialogRef = inject('dialogRef') as Ref;
const listTour = dialogRef?.value?.data?.listTour;
const toursSelected = dialogRef?.value?.data?.tourSelected;
const onSaveSelectRoom = dialogRef.value.options.emits.onSaveSelectRoom;

const applyPricingTour = (tourSelected: any) => {
  onSaveSelectRoom(tourSelected);
};
</script>
<template>
  <div class="pricing-modal">
    <SelectTourProcess @applyPricing="(tourSelected) => applyPricingTour(tourSelected)" :listTour="listTour" :toursSelected="toursSelected" />
  </div>
</template>
